import Vue from "vue";
import Vuex from "vuex";
import state from "./state";
import * as otherActions from "./actions/actions";
import * as authActions from "./actions/authActions";
import * as getPatientExamActions from "./actions/getPatientExamActions";
import * as getHelpCenterActions from "./actions/getHelpCenterActions";
import * as getImageActions from "./actions/getImageActions";
import * as multiviewActions from "./actions/multiviewActions";
import * as proofsheetActions from "./actions/proofsheetActions";
import * as deepDeeActions from "./actions/deepDeeActions.js"
import * as mutations from "./mutations";
import * as getters from "./getters";
import { logDetailed } from "../helpers/utils";
import "./axiosSetup";

Vue.use(Vuex);

const store = new Vuex.Store({
  state,
  actions: {
    ...otherActions, ...authActions, ...getPatientExamActions, ...getHelpCenterActions,
    ...getImageActions, ...multiviewActions, ...proofsheetActions, ...deepDeeActions
  },
  mutations,
  getters
});

store.subscribe((mutation, state) => {
  let localState = { 
    userPrefs: state.userPrefs,
    mfa: state.mfa,
    physicians: state.physicians,
    devices: state.devices,
    procedures: state.procedures,
    ssoSearch: state.ssoSearch,
    emrProSearchParams: state.emrProSearchParams,
    wasEmrPro: state.wasEmrPro
  };
  let json = JSON.stringify(localState);
  sessionStorage.setItem("store", json);
});

window.addEventListener("storage", function(e){
  logDetailed("index", "storageEvent", e);
});

export default store;
